import React, { useState } from 'react';
import { Button } from '../../ui';
import { createAuditedClient } from '../../utils/auditClient';
import { downloadHandoverContractPdf } from '../../handover/downloadHandoverContractPdf';
import { COLORS } from '../../handover/handoverStyles';

const client = createAuditedClient('HandoverPdfDownloadButton');

export default function HandoverPdfDownloadButton({
  handoverId,
  label = 'Download contract PDF',
  onError,
  style,
}) {
  const [loading, setLoading] = useState(false);

  if (!handoverId) return null;

  const handleClick = async () => {
    setLoading(true);
    try {
      await downloadHandoverContractPdf(client, handoverId, {
        onPending: () => {
          setLoading(true);
        },
      });
    } catch (err) {
      console.error('Failed to download handover contract PDF', err);
      onError?.({
        type: 'error',
        title: 'PDF download failed',
        message: err?.message || 'Could not generate the contract PDF.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      disabled={loading}
      style={{
        marginTop: 10,
        padding: '8px 14px',
        fontSize: 13,
        fontWeight: 600,
        borderRadius: 8,
        border: `1px solid ${COLORS.gray[300]}`,
        background: '#fff',
        color: COLORS.gray[800],
        ...style,
      }}
    >
      {loading ? 'Preparing PDF…' : label}
    </Button>
  );
}

export function canDownloadHandoverPdf(groups = []) {
  return groups.includes('admin') || groups.includes('country_admin');
}
